import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Nav,
  NavItem,
  TabContent,
  Table,
  TabPane,
  NavLink,
  Tooltip,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  GET_LICENSE_PLAN,
  GET_SINGLE_LICENSE,
} from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { Link } from "react-router-dom";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import BackButtonSvg from "../../common/BackButtonSvg";
import { Info } from "../../common/Info";
import moment from "moment";

function TemplateDetails(props) {
  const history = useNavigate();
  const [Data, setData] = useState({});

  const [LicensePlan, setLicensePlan] = useState([]);

  const { templateId } = useParams();
  localStorage.setItem("PAY_PUP_LS_TEMPLATE_ID", templateId);
  const { enqueueSnackbar } = useSnackbar();
  const [activeTab, setActiveTab] = useState("1");
  const [Loading, setLoading] = useState(false);
  const [CategoryList, setCategoryList] = useState([]);
  const tabtoggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };

  const Gettemplate = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_SINGLE_LICENSE,
      headers: authHeader(),
      params: {
        templateId: templateId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setData(data);
        setCategoryList(JSON.parse(data.categoryDetails || "[]"));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const GetPlan = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_LICENSE_PLAN,
      headers: authHeader(),
      params: {
        templateId: templateId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setLicensePlan(data);
      }
    } catch (error) {
      const { data } = error.response;
      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    Gettemplate();
    GetPlan();
  }, []);

const stripHtml = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || '';
};
//    const InstructionBox = ({ html }) => {
//      if (!html) return <div style={{justifyContent: 'center', display: 'flex', fontSize: 'initial' }}>There are no instructions available.</div>;

//      return <div dangerouslySetInnerHTML={{ __html: html }} />;
// };
  const InstructionBox = ({ html }) => {
    if (!html) return <div style={{justifyContent: 'center', display: 'flex', fontSize: 'initial' }}>There are no instructions available.</div>;
    const removeTag = html.replace(/<p>/gi, '<p style="margin: 0; padding: 0;">');
    // const removeTag1 = removeTag.replace(/<strong>/gi, '<strong style="margin: 0; padding: 0; display: inline; font-weight: bold; line-height: 1;">');
    const changeTag = removeTag.replace(/<br\s*\/?>/gi, `<div style="line-height: 1em; height: 1.0em;"></div>`);
  return <div style={{margin:0, padding: 0}} dangerouslySetInnerHTML={{ __html: changeTag }} />;
};
  return (
    <div>
      <div className="wrapper">
        {Loading && <CustomPageLoading />}

        <Container fluid>
          <div className="page-title">
            <h4>{Data.licenseName}</h4>

            <div className="top-btn">
              <Button color="primary" onClick={back}>
                <BackButtonSvg />
                Back
              </Button>
            </div>
          </div>

          <div>
            <Nav tabs className="mt-3">
              <NavItem>
                <NavLink
                  className={{ active: activeTab === "1" }}
                  onClick={() => {
                    tabtoggle("1");
                  }}
                >
                  Category
                  <Tooltip
                    isOpen={id === "category" && tooltipOpen}
                    target={"category"}
                    toggle={() => toggle("category")}
                  >
                    View category details
                  </Tooltip>
                  <span id={"category"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={{ active: activeTab === "2" }}
                  onClick={() => {
                    tabtoggle("2");
                  }}
                >
                  Plans
                  <Tooltip
                    isOpen={id === "plans" && tooltipOpen}
                    target={"plans"}
                    toggle={() => toggle("plans")}
                  >
                    View plan details
                  </Tooltip>
                  <span id={"plans"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={{ active: activeTab === "3" }}
                  onClick={() => {
                    tabtoggle("3");
                  }}
                >
                  Instructions
                  <Tooltip
                    isOpen={id === "instructions" && tooltipOpen}
                    target={"instructions"}
                    toggle={() => toggle("instructions")}
                  >
                    View instructions details
                  </Tooltip>
                  <span id={"instructions"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Card body className="mt-4 create-min-card">
                  <Row className="category-list">
                    <Table>
                      <thead>
                        <tr>
                          {" "}
                          <th>Category Order</th>
                          <th>Category Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      {CategoryList.length === 0 ? (
                        <tr>
                          <td colSpan={3}>
                            <center>No Records Found</center>
                          </td>
                        </tr>
                      ) : (
                        <>
                          <tbody>
                            {CategoryList.map((cat) => (
                              <tr>
                                <td>{cat.categoryOrder}</td>
                                <td>{cat.categoryName}</td>
                                <td>
                                  {" "}
                                  <div className="btn-section">
                                    <Link
                                      to={{
                                        pathname: `${"/admin/templateform"}/${
                                          cat.categoryId
                                        }`,
                                        state: {
                                          categoryName: cat.categoryName,
                                          categoryOrder: cat.categoryOrder,
                                        },
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16.216"
                                        height="10.811"
                                        viewBox="0 0 16.216 10.811"
                                      >
                                        <path
                                          id="Icon_awesome-eye"
                                          data-name="Icon awesome-eye"
                                          d="M16.118,9.494A9.03,9.03,0,0,0,8.108,4.5,9.031,9.031,0,0,0,.1,9.495a.911.911,0,0,0,0,.822,9.03,9.03,0,0,0,8.01,4.994,9.031,9.031,0,0,0,8.01-4.995A.911.911,0,0,0,16.118,9.494Zm-8.01,4.465a4.054,4.054,0,1,1,4.054-4.054A4.054,4.054,0,0,1,8.108,13.959Zm0-6.757a2.683,2.683,0,0,0-.713.107A1.347,1.347,0,0,1,5.512,9.193a2.7,2.7,0,1,0,2.6-1.99Z"
                                          transform="translate(0 -4.5)"
                                          fill="#1b3e6f"
                                        ></path>
                                      </svg>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </>
                      )}
                    </Table>
                  </Row>
                </Card>
              </TabPane>

              <TabPane tabId="2">
                <Card body className="mt-4 create-min-card">
                  <Row className="mt-4 create-plan plan-list">
                    {LicensePlan.length === 0 ? (
                      "No Record Found"
                    ) : (
                      <>
                        {LicensePlan.map((i) => (
                          <Col md="4">
                            <div className="box">
                              <h4>{i.planName}</h4>
                              <h1>
                                <strong>$</strong>
                                {parseFloat(i.planAmount).toFixed(2)}
                              </h1>
                              <span>
                                {i.isLifeTimePlan && "Life Time Plan"}

                                {!!i.validTo && (
                                  <>
                                    <span>Till Date</span>{" "}
                                    {moment(i.validTo).format("MM-DD-YYYY")}
                                  </>
                                )}
                                {!!i.planDuration && i.planDuration + "/ month"}
                              </span>
                              <ul>
                                <li>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17.011"
                                    height="17.011"
                                    viewBox="0 0 17.011 17.011"
                                  >
                                    <path
                                      id="Icon_material-check-box"
                                      data-name="Icon material-check-box"
                                      d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                                      transform="translate(-4.5 -4.5)"
                                      fill="#fff"
                                    />
                                  </svg>

                                  {i.isRenewal ? (
                                    <>
                                      {" "}
                                      Renewal for{" "}
                                      {i.isKennelLicense
                                        ? "kennel license"
                                        : i.isParkLicense
                                        ? "Park License"
                                        : i.isDogLicense
                                        ? "Dog License"
                                        : ""}{" "}
                                    </>
                                  ) : (
                                    <>
                                      {i.isKennelLicense
                                        ? "kennel license"
                                        : i.isParkLicense
                                        ? "Park License"
                                        : i.isDogLicense
                                        ? "Dog License"
                                        : ""}
                                    </>
                                  )}
                                </li>
                              </ul>
                              <p>{i.planDescription}</p>

                              {JSON.parse(i.CategoryDetails).map((i) => (
                                <ul>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17.011"
                                      height="17.011"
                                      viewBox="0 0 17.011 17.011"
                                    >
                                      <path
                                        id="Icon_material-check-box"
                                        data-name="Icon material-check-box"
                                        d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                                        transform="translate(-4.5 -4.5)"
                                        fill="#fff"
                                      />
                                    </svg>
                                    {i.categoryName}
                                  </li>
                                </ul>
                              ))}
                            </div>
                          </Col>
                        ))}
                      </>
                    )}
                  </Row>
                </Card>
              </TabPane>
            </TabContent>
            {activeTab == 3 && (
              // <div style={{
              //   backgroundColor: '#f9f9f9',
              //   border: '2px solid #ddd',
              //   borderRadius: '8px',
              //   padding: '16px 24px',
              //   maxWidth: '100%',
              //   boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
              //   fontFamily: 'sans-serif'
              // }}>
              //   <h2 style={{ marginTop: 0 }}>Instructions</h2>
              //   <p style={{alignItems: 'center'}}>{Data && Data.instruction ?  stripHtml(Data.instruction) : 'There are no instructions available.'}</p>
              // </div>
              <div style={{
                backgroundColor: '#f9f9f9',
                border: '2px solid #ddd',
                borderRadius: '8px',
                padding: '16px 24px',
                maxWidth: '100%',
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                fontFamily: 'sans-serif'
              }}>
                <h4>Instructions</h4>
                  {(Data && Data.instruction && stripHtml(Data.instruction).length) ? (
                    <InstructionBox html={Data.instruction} />
                  ) : (
                    <div style={{justifyContent: 'center', display: 'flex', fontSize: 'initial' }}>There are no instructions available.</div>
                  )}
                </div>
            )}    
          </div>
        </Container>
      </div>
    </div>
  );
}

export default TemplateDetails;
